import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { merge } from 'rxjs';
import { InviteDao } from '../../../core/services/dao/inviteDao';

@Injectable()
export class CreateAccountResolve implements Resolve<any> {
  constructor(private inviteDao: InviteDao) {}

  resolve(route: ActivatedRouteSnapshot) {
    const inviteResolve = this.inviteDao.getInvite(route.params.inviteId);
    return merge(inviteResolve);
  }
}
